import { DatepickerMultipleDateFormat } from './types';

const formatMinimumIntegerDigits = (
  minimumIntegerDigits: number,
  value: number
) => new Intl.NumberFormat('ru-RU', { minimumIntegerDigits }).format(value);

export const transformDateToInputFormat = (date: string) =>
  date.replace(/^(\d{4})-(\d{2})-(\d{2})$/, '$3.$2.$1');

export const getFormattedDatePart = (part: string) => {
  const isSingleNumberPart = /^\d$/.test(part);
  if (!isSingleNumberPart) return part;
  return formatMinimumIntegerDigits(2, +part);
};

export const transformMultipleFieldDateToCalendarFormat = ({
  day,
  month,
  year,
}: DatepickerMultipleDateFormat) =>
  `${year}-${getFormattedDatePart(month)}-${getFormattedDatePart(day)}`;

export const transformMultipleDateToCalendarFormat = ({
  day,
  month,
  year,
}: DatepickerMultipleDateFormat) => `${year}-${month}-${day}`;

export const inputToCalendarFormatConverter = (date: string) => {
  if (!date) return '';
  const dateParts = date.split('.').reverse();
  return `${dateParts[0] || ''}-${dateParts[1] || ''}-${dateParts
    .slice(2)
    .join('.')}`;
};

export const dateCalendarFormatValidator = (date: string) =>
  /^\d{4}-\d{2}-\d{2}$/.test(date);

export const externalDateValidator = (date: string) => {
  if (!dateCalendarFormatValidator(date)) return false;

  const originalDate = new Date(date);
  const originalDateParts = [
    originalDate.getFullYear(),
    originalDate.getMonth() + 1,
    originalDate.getDate(),
  ];
  const externalDateParts = date.split('-').map(Number);

  return (
    JSON.stringify(originalDateParts) === JSON.stringify(externalDateParts)
  );
};

export const transformSingleDateToStandard = (value: string) => {
  let dateParts = value.split('.');
  let formattedDate = dateParts
    .map((item) => getFormattedDatePart(item))
    .join('.');

  let standardizedDate = inputToCalendarFormatConverter(formattedDate);
  let isDateValid = externalDateValidator(standardizedDate);

  return isDateValid ? [standardizedDate] : undefined;
};
